import React from 'react';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { useComboList } from 'hooks';
import { ComboCarousel, ComboCarouselNew } from 'components/desktop/organisms';

export const ProductCombo: React.FC = () => {
  const { epicOmni1286 } = useTenantConfig();
  const { product } = useProductDetailState();
  const { comboList } = useComboList(product?.sku);
  return (
    <>
      {!epicOmni1286 && !!comboList?.length && product?.sku && (
        <ComboCarousel comboList={comboList} mainSku={product?.sku} />
      )}
      {epicOmni1286 && product?.sku && <ComboCarouselNew />}
    </>
  );
};
